import { textSizeStyles, textWeightStyles } from '@tuhi/components'
import { contentColorStyle } from '@tuhi/components/src/redesign/buttons/button'
import { SectionItem } from 'app/features/legal/components/section'
import { FC } from 'react'
import { styled } from 'styled-components'
import { media } from '@tuhi/components/src/theme/breakpoints'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    gap: 16px;

    border-right: 2px solid;
    border-image-source: ${(p) =>
        `linear-gradient(180deg, ${p.theme.colors.tertiary.tertiary50} 0%, ${p.theme.colors.tertiary.tertiary100} 46.5%, ${p.theme.colors.tertiary.default} 100%)`};
    border-image-slice: 1;

    ${media.mobile} {
        display: none;
    }
`

const Anchor = styled.button`
    text-decoration: none;
    background-color: transparent;
    border: unset;
    text-align: left;
    white-space: nowrap;

    ${(p) => contentColorStyle(p.theme.colors.tertiary.tertiary900)}
    ${textSizeStyles['small']}
    ${textWeightStyles['semiBold']}


    &.active {
        ${(p) => contentColorStyle(p.theme.colors.primary.default)}
    }
`

interface Props {
    anchors: SectionItem[]
    activeId: string
    setActiveId: React.Dispatch<React.SetStateAction<string>>
    scrollingRef: React.MutableRefObject<boolean>
}

export const SideBar: FC<Props> = ({
    anchors,
    activeId,
    setActiveId,
    scrollingRef,
}) => {
    const handleScrollToSection = (id: string) => {
        const section = document.getElementById(id)
        if (section) {
            scrollingRef.current = true
            setActiveId(id)
            section.scrollIntoView({ behavior: 'smooth', block: 'start' })

            // Reset the flag after a delay to allow scroll to complete
            setTimeout(() => {
                scrollingRef.current = false
            }, 500) // Adjust this as needed
        }
    }

    return (
        <Container>
            {anchors.map((anchor) => (
                <Anchor
                    key={anchor.id}
                    onClick={() => handleScrollToSection(anchor.id)}
                    className={activeId === anchor.id ? 'active' : ''}
                >
                    {anchor.title}
                </Anchor>
            ))}
        </Container>
    )
}
